/*eslint-disable*/
import {
  GET_ENUMS,
  GET_SECTIONS,
  SAVE_SURVEY,
  UPDATE_ENUMS,
  UPDATE_SURVEY,
  GET_ENUMS_FILTERED,
  GET_SPECIFIC_STRUCTURE,
} from "../actionTypes";

const initialState: SurveyState = {
  sections: [],
  enums: [],
};

const sectionReducer = (
  state: SurveyState = initialState,
  action: SurveyAction
) => {
  switch (action.type) {
    case GET_SECTIONS:
      return {
        ...state,
        sections: action.payload,
        sort_sections: action.sort_sections,
      };

    case GET_SPECIFIC_STRUCTURE:
      return {
        ...state,
        specificStructure: action.payload,
      };
    case GET_ENUMS:
      return {
        ...state,
        enums: action.payload,
      };
    case GET_ENUMS_FILTERED:
      return {
        ...state,
        enumsFiltered: action.payload,
      };
    case SAVE_SURVEY:
      return {
        ...state,
      };
    case UPDATE_SURVEY:
      return {
        ...state,
        sections: action.payload,
      };
    case UPDATE_ENUMS:
      return {
        ...state,
        enums: { ...state.enums, "legal-forms": action.payload },
      };
    default:
      return state;
  }
};

export default sectionReducer;
